/**
 * How closely the tree is being looked at, in the four steps that change what
 * a circle draws. It used to be handed the camera's raw scale, which changes on
 * every frame of a pinch — so every circle in the family re-rendered sixty times
 * a second to decide, sixty times a second, that nothing about it had changed.
 * A band only changes when a threshold is crossed.
 *
 * On its own, with nothing of the screen in it, so the rule can be tested
 * without drawing anything.
 */
export type ZoomBand = 'veryFar' | 'far' | 'near' | 'close';

export function zoomBandOf(scale: number): ZoomBand {
  if (scale < 0.26) return 'veryFar';
  if (scale < 0.42) return 'far';
  // Past here a circle is as big on a phone's screen as its small copy is wide: time for the real photograph.
  if (scale < 1) return 'near';
  return 'close';
}
